{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Hệ thống",
    "AVATAR": {
      "SUCCESS_DELETE": "Đã xóa ảnh đại diện Bot thành công",
      "ERROR_DELETE": "Lỗi khi xóa ảnh đại diện Bot, vui lòng thử lại"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "Bot này sẽ làm gì?"
      },
      "BOT_CONFIG": {
        "ERROR": "",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Cập nhật",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bot theo quốc gia",
        "DESC": "Hộp thư này phục vụ nhiều quốc gia. Cuộc hội thoại được chuyển đến bot của quốc gia đó: theo gian hàng Kaufland, theo sàn của đơn hàng Allegro, hoặc nếu không có thì theo ngôn ngữ người mua viết. Mọi cuộc hội thoại khác được chuyển đến bot mặc định ở trên.",
        "COUNTRY": "Chọn quốc gia",
        "BOT": "Chọn bot",
        "ADD": "Thêm bot cho quốc gia",
        "REMOVE": "Xóa",
        "DEFAULT_REQUIRED": "Hãy chọn bot mặc định trước. Bot của một quốc gia chỉ thay thế bot mặc định cho quốc gia đó.",
        "DISCONNECT_ALL": "Ngắt kết nối tất cả bot"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Chi tiết Bot",
        "URL": "Webhook URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Xoá",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Xác nhận Xóa",
        "MESSAGE": "Bạn có chắc chắn muốn xóa {name} không?",
        "YES": "Có, Xóa",
        "NO": "Không, Giữ lại"
      },
      "SUBMIT": "Xoá",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Chỉnh sửa",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Ảnh đại diện Bot"
      },
      "NAME": {
        "LABEL": "Tên Bot",
        "PLACEHOLDER": "Nhập tên Bot"
      },
      "DESCRIPTION": {
        "LABEL": "Mô tả",
        "PLACEHOLDER": "Bot này sẽ làm gì?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Cần có tên Bot",
        "URL": "Cần có Webhook URL",
        "VALID_URL": "Vui lòng nhập URL hợp lệ bắt đầu bằng http:// hoặc https://"
      },
      "CANCEL": "Huỷ",
      "CREATE": "Tạo Bot",
      "UPDATE": "Cập nhật Bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
